export class ResolutionReadsPostRequest {
  resolutionId!: string
}
